import { Component, inject } from "@angular/core";
import { CommonModule } from "@angular/common";
import { Icon, ModalAdapter, ModalContainer } from "@client";
import { KakaoService } from "@namdorang/api-client";
import { environment } from "apps/client/src/environments/environment";
import { HttpClient } from "@angular/common/http";
import { RouterLink } from "@angular/router";

declare const Kakao: any;

@Component({
  selector: "app-login",
  imports: [CommonModule, ModalContainer, Icon, RouterLink],
  templateUrl: "./login.modal.html",
  styleUrl: "./login.modal.scss",
})
export class LoginModal extends ModalAdapter {
  kakaoService = inject(KakaoService);
  http = inject(HttpClient);

  login() {
    const isInitialized = Kakao.isInitialized();
    if (!isInitialized) Kakao.init(environment.kakaoAppKey);
    Kakao.Auth.authorize({
      redirectUri: `${window.origin}/home`,
    });
  }
}
